import { useTranslation } from 'react-i18next';
import { useQuestionEditorContext } from '../context/create-question.context';
import HubertSwitch from 'components/HubertUI/HubertSwitch';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionDeferrable, selectQuestionIsReadonly } from 'rtk/questionEditorSelector';
import { updateDeferrable } from 'rtk/Question.Editor.Slice';

const DeferrableSwitch = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const deferrable = useAppSelector((state) => selectQuestionDeferrable(state, questionId));
  const disabled = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));

  return (
    <div className="flex flex-row items-center justify-between gap-4 py-1">
      <HubertLabel htmlFor="create-question-deferrable" className="cursor-pointer text-sm">
        {t('deferrable.label')}
      </HubertLabel>
      <HubertSwitch
        id="create-question-deferrable"
        disabled={disabled}
        checked={deferrable}
        onCheckedChange={(checked: boolean) => dispatch(updateDeferrable({ questionId, value: checked }))}
      />
    </div>
  );
};

export default DeferrableSwitch;
